export default __webpack_public_path__ + "static/media/icon-upload-photo.96dd0bdd.svg";